import { Theme, ThemeName, ThemeNameValues } from './theme';
import { themeFunStreet } from './themeFunStreet';
import { themeScrapyard } from './themeScrapyard';
import { themeCitySky } from './themeCitySky';
import { themeDocks } from './themeDocks';
import { themeFrozenStreet } from './themeFrozenStreet';

export class ThemeUtil {
  public static themeLookup: Record<ThemeNameValues, Theme> = {
    [ThemeName.FunStreet]: themeFunStreet,
    [ThemeName.Scrapyard]: themeScrapyard,
    [ThemeName.CitySky]: themeCitySky,
    [ThemeName.Docks]: themeDocks,
    [ThemeName.FrozenStreet]: themeFrozenStreet
  };

  public static getTheme = (theme: ThemeNameValues): Theme => {
    return this.themeLookup[theme];
  };
}
